import React from 'react';

interface TermsAndConditionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
  onDecline: () => void;
}

export const TermsAndConditionsModal: React.FC<
  TermsAndConditionsModalProps
> = ({ isOpen, onClose, onAccept, onDecline }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div
        className="bg-white rounded-lg shadow-xl flex flex-col"
        style={{
          width: '600px',
          height: '65vh',
          maxWidth: '90vw',
          maxHeight: '90vh',
        }}
      >
        {/* Header */}
        <div className="flex justify-between items-center p-6 pb-0">
          <p className="text-lg font-light text-gray-900">AGREEMENT</p>

          {/* <h2 className="text-xl font-bold text-gray-900">Terms and Conditions</h2> */}
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">
          <div className="space-y-4 text-gray-700 text-sm leading-relaxed">
            <h3 className="text-lg font-semibold text-gray-900 border-b pb-2">
              Terms and Conditions
            </h3>
            {/* <h3>Terms and Conditions</h3> */}

            <h3 className="font-bold text-gray-700">
              Last Updated on 10/01/2025
            </h3>
            <p className="pb-2">
              Agreement between user and www.wildgamebutcher.com <br></br>
              Welcome to www.wildgamebutcher.com. The www.wildgamebutcher.com
              website (the &quot;Site&quot;) is comprised of various web pages
              operated by Techaffinity Consulting, Inc (&quot;Taffinc&quot;).
              www.wildgamebutcher.com is offered to you conditioned on your
              acceptance without modification of the terms, conditions, and
              notices contained herein (the &quot;Terms&quot;). Your use of
              www.wildgamebutcher.com constitutes your agreement to all such
              Terms. Please read these terms carefully, and keep a copy of them
              for your reference.
            </p>

            <p className="pb-2">
              www.wildgamebutcher.com is an E-Commerce Site. Butcher shop for
              hunters
            </p>

            <div className="pb-2">
              <h4 className="font-lg font-bold">Privacy</h4>
              <p>
                Your use of www.wildgamebutcher.com is subject to Taffinc&apos;s
                Privacy Policy. Please review our Privacy Policy, which also
                governs the Site and informs users of our data collection
                practices.
              </p>
            </div>

            <div className="pb-2">
              <h4 className="font-lg font-bold">Electronic Communications</h4>
              <p>
                Visiting www.wildgamebutcher.com or sending emails to
                wildgamebutcher.com constitutes electronic communications. You
                consent to receive electronic communications and you agree that
                all agreements, notices, disclosures and other communications
                that we provide to you electronically, via email and on the
                Site, satisfy any legal requirement that such communications be
                in writing.
              </p>
            </div>

            <div className="pb-2">
              <h4 className="font-lg font-bold">Your Account</h4>
              <p>
                If you use this site, you are responsible for maintaining the
                confidentiality of your account and password and for restricting
                access to your computer, and you agree to accept responsibility
                for all activities that occur under your account or password.
                You may not assign or otherwise transfer your account to any
                other person or entity. You acknowledge that Taffinc is not
                responsible for third party access to your account that results
                from theft or misappropriation of your account. Taffinc and its
                associates reserve the right to refuse or cancel service,
                terminate accounts, or remove or edit content in our sole
                discretion.
              </p>
            </div>

            <div className="pb-2">
              <h4 className="font-lg font-bold">Children Under Thirteen</h4>
              <p>
                Taffinc does not knowingly collect, either online or offline,
                personal information from persons under the age of thirteen. If
                you are under 18, you may use www.wildgamebutcher.com only with
                permission of a parent or guardian.
              </p>
            </div>

            <div className="pb-2">
              <h4 className="font-lg font-bold">Cancellation/Refund Policy</h4>
              <p>
                You may cancel or modify your order only if the process has not
                yet begun.
              </p>
            </div>

            <div className="pb-2">
              <h4 className="font-lg font-bold">
                Links to Third Party Sites/Third Party Services
              </h4>
              <p>
                www.wildgamebutcher.com may contain links to other websites
                (&quot;Linked Sites&quot;). The Linked Sites are not under the
                control of Taffinc and Taffinc is not responsible for the
                contents of any Linked Site, including without limitation any
                link contained in a Linked Site, or any changes or updates to a
                Linked Site. Taffinc is providing these links to you only as a
                convenience, and the inclusion of any link does not imply
                endorsement by Taffinc of the site or any association with its
                operators.
              </p>
              <p>
                Certain services made available via www.wildgamebutcher.com are
                delivered by third party sites and organizations. By using any
                product, service or functionality originating from the
                www.wildgamebutcher.com, you hereby acknowledge and consent that
                Taffinc may share such information and data with any third party
                with whom Taffinc has a contractual relationship to provide the
                requested product, service or functionality on behalf of
                www.wildgamebutcher.com users and customers.
              </p>
            </div>

            <div className="pb-2">
              <h4 className="font-lg font-bold">
                No Unlawful or Prohibited Use/Intellectual Property
              </h4>
              <p>
                You are granted a non-exclusive, non-transferable, revocable
                license to access and use www.wildgamebutcher.com strictly in
                accordance with these terms of use. As a condition of your use
                of the Site, you warrant to Taffinc that you will not use the
                Site for any purpose that is unlawful or prohibited by these
                Terms. You may not use the Site in any manner which could
                damage, disable, overburden, or impair the Site or interfere
                with any other party&apos;s use and enjoyment of the Site. You
                may not obtain or attempt to obtain any materials or information
                through any means not intentionally made available or provided
                for through the Site.
              </p>
              <p>
                All content included as part of the Service, such as text,
                graphics, logos, images, as well as the compilation thereof, and
                any software used on the Site, is the property of Taffinc or its
                suppliers and protected by copyright and other laws that protect
                intellectual property and proprietary rights. You agree to
                observe and abide by all copyright and other proprietary
                notices, legends or other restrictions contained in any such
                content and will not make any changes thereto.
              </p>
              <p>
                You will not modify, publish, transmit, reverse engineer,
                participate in the transfer or sale, create derivative works, or
                in any way exploit any of the content, in whole or in part,
                found on the Site. Taffinc content is not for resale. Your use
                of the Site does not entitle you to make any unauthorized use of
                any protected content, and in particular you will not delete or
                alter any proprietary rights or attribution notices in any
                content. You will use protected content solely for your personal
                use, and will make no other use of the content without the
                express written permission of Taffinc and the copyright owner.
                You agree that you do not acquire any ownership rights in any
                protected content. We do not grant you any licenses, express or
                implied, to the intellectual property of Taffinc or our
                licensors except as expressly authorized by these Terms.
              </p>
            </div>

            <div className="pb-2">
              <h4 className="font-lg font-bold">International Users</h4>
              <p>
                The Service is controlled, operated and administered by Taffinc
                from our offices within the USA. If you access the Service from
                a location outside the USA, you are responsible for compliance
                with all local laws. You agree that you will not use the Taffinc
                Content accessed through www.wildgamebutcher.com in any country
                or in any manner prohibited by any applicable laws, restrictions
                or regulations.
              </p>
            </div>

            <div className="pb-2">
              <h4 className="font-lg font-bold">Indemnification</h4>
              <p>
                You agree to indemnify, defend and hold harmless Taffinc, its
                officers, directors, employees, agents and third parties, for
                any losses, costs, liabilities and expenses (including
                reasonable attorney&apos;s fees) relating to or arising out of
                your use of or inability to use the Site or services, any user
                postings made by you, your violation of any terms of this
                Agreement or your violation of any rights of a third party, or
                your violation of any applicable laws, rules or regulations.
                Taffinc reserves the right, at its own cost, to assume the
                exclusive defense and control of any matter otherwise subject to
                indemnification by you, in which event you will fully cooperate
                with Taffinc in asserting any available defenses.
              </p>
            </div>

            <div className="pb-2">
              <h4 className="font-lg font-bold">Arbitration</h4>
              <p>
                In the event the parties are not able to resolve any dispute
                between them arising out of or concerning these Terms and
                Conditions, or any provisions hereof, whether in contract, tort,
                or otherwise at law or in equity for damages or any other
                relief, then such dispute shall be resolved only by final and
                binding arbitration pursuant to the Federal Arbitration Act,
                conducted by a single neutral arbitrator and administered by the
                American Arbitration Association, or a similar arbitration
                service selected by the parties, in a location mutually agreed
                upon by the parties. The arbitrator&apos;s award shall be final,
                and judgment may be entered upon it in any court having
                jurisdiction. In the event that any legal or equitable action,
                proceeding or arbitration arises out of or concerns these Terms
                and Conditions, the prevailing party shall be entitled to
                recover its costs and reasonable attorney&apos;s fees. The
                parties agree to arbitrate all disputes and claims in regards to
                these Terms and Conditions or any disputes arising as a result
                of these Terms and Conditions, whether directly or indirectly,
                including Tort claims that are a result of these Terms and
                Conditions. The parties agree that the Federal Arbitration Act
                governs the interpretation and enforcement of this provision.
                The entire dispute, including the scope and enforceability of
                this arbitration provision shall be determined by the
                Arbitrator. This arbitration provision shall survive the
                termination of these Terms and Conditions.
              </p>
            </div>

            <div className="pb-2">
              <h4 className="font-lg font-bold">Liability Disclaimer</h4>
              <p>
                THE INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES INCLUDED IN OR
                AVAILABLE THROUGH THE SITE MAY INCLUDE INACCURACIES OR
                TYPOGRAPHICAL ERRORS. CHANGES ARE PERIODICALLY ADDED TO THE
                INFORMATION HEREIN. TECHAFFINITY CONSULTING, INC AND/OR ITS
                SUPPLIERS MAY MAKE IMPROVEMENTS AND/OR CHANGES IN THE SITE AT
                ANY TIME.
              </p>
              <p>
                TECHAFFINITY CONSULTING, INC AND/OR ITS SUPPLIERS MAKE NO
                REPRESENTATIONS ABOUT THE SUITABILITY, RELIABILITY,
                AVAILABILITY, TIMELINESS, AND ACCURACY OF THE INFORMATION,
                SOFTWARE, PRODUCTS, SERVICES AND RELATED GRAPHICS CONTAINED ON
                THE SITE FOR ANY PURPOSE. TO THE MAXIMUM EXTENT PERMITTED BY
                APPLICABLE LAW, ALL SUCH INFORMATION, SOFTWARE, PRODUCTS,
                SERVICES AND RELATED GRAPHICS ARE PROVIDED &quot;AS IS&quot;
                WITHOUT WARRANTY OR CONDITION OF ANY KIND. TECHAFFINITY
                CONSULTING, INC AND/OR ITS SUPPLIERS HEREBY DISCLAIM ALL
                WARRANTIES AND CONDITIONS WITH REGARD TO THIS INFORMATION,
                SOFTWARE, PRODUCTS, SERVICES AND RELATED GRAPHICS, INCLUDING ALL
                IMPLIED WARRANTIES OR CONDITIONS OF MERCHANTABILITY, FITNESS FOR
                A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT.
              </p>
              <p>
                TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT
                SHALL TECHAFFINITY CONSULTING, INC AND/OR ITS SUPPLIERS BE
                LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL,
                CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER INCLUDING,
                WITHOUT LIMITATION, DAMAGES FOR LOSS OF USE, DATA OR PROFITS,
                ARISING OUT OF OR IN ANY WAY CONNECTED WITH THE USE OR
                PERFORMANCE OF THE SITE, WITH THE DELAY OR INABILITY TO USE THE
                SITE OR RELATED SERVICES, THE PROVISION OF OR FAILURE TO PROVIDE
                SERVICES, OR FOR ANY INFORMATION, SOFTWARE, PRODUCTS, SERVICES
                AND RELATED GRAPHICS OBTAINED THROUGH THE SITE, OR OTHERWISE
                ARISING OUT OF THE USE OF THE SITE, WHETHER BASED ON CONTRACT,
                TORT, NEGLIGENCE, STRICT LIABILITY OR OTHERWISE, EVEN IF
                TECHAFFINITY CONSULTING, INC OR ANY OF ITS SUPPLIERS HAS BEEN
                ADVISED OF THE POSSIBILITY OF DAMAGES. BECAUSE SOME
                STATES/JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF
                LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, THE ABOVE
                LIMITATION MAY NOT APPLY TO YOU. IF YOU ARE DISSATISFIED WITH
                ANY PORTION OF THE SITE, OR WITH ANY OF THESE TERMS OF USE, YOUR
                SOLE AND EXCLUSIVE REMEDY IS TO DISCONTINUE USING THE SITE.
              </p>
            </div>

            <div className="pb-2">
              <h4 className="font-lg font-bold">
                Termination/Access Restriction
              </h4>
              <p>
                Taffinc reserves the right, in its sole discretion, to terminate
                your access to the Site and the related services or any portion
                thereof at any time, without notice. To the maximum extent
                permitted by law, this agreement is governed by the laws of the
                State of Florida and you hereby consent to the exclusive
                jurisdiction and venue of courts in Florida in all disputes
                arising out of or relating to the use of the Site. Use of the
                Site is unauthorized in any jurisdiction that does not give
                effect to all provisions of these Terms, including, without
                limitation, this section.
              </p>
              <p>
                You agree that no joint venture, partnership, employment, or
                agency relationship exists between you and Taffinc as a result
                of this agreement or use of the Site. Taffinc&apos;s performance
                of this agreement is subject to existing laws and legal process,
                and nothing contained in this agreement is in derogation of
                Taffinc&apos;s right to comply with governmental, court and law
                enforcement requests or requirements relating to your use of the
                Site or information provided to or gathered by Taffinc with
                respect to such use. If any part of this agreement is determined
                to be invalid or unenforceable pursuant to applicable law
                including, but not limited to, the warranty disclaimers and
                liability limitations set forth above, then the invalid or
                unenforceable provision will be deemed superseded by a valid,
                enforceable provision that most closely matches the intent of
                the original provision and the remainder of the agreement shall
                continue in effect.
              </p>
              <p>
                Unless otherwise specified herein, this agreement constitutes
                the entire agreement between the user and Taffinc with respect
                to the Site and it supersedes all prior or contemporaneous
                communications and proposals, whether electronic, oral or
                written, between the user and Taffinc with respect to the Site.
                A printed version of this agreement and of any notice given in
                electronic form shall be admissible in judicial or
                administrative proceedings based upon or relating to this
                agreement to the same extent and subject to the same conditions
                as other business documents and records originally generated and
                maintained in printed form. It is the express wish to the
                parties that this agreement and all related documents be written
                in English.
              </p>
            </div>

            <div className="pb-2">
              <h4 className="font-lg font-bold">Changes to Terms</h4>
              <p>
                Taffinc reserves the right, in its sole discretion, to change
                the Terms under which www.taffinc.com is offered. The most
                current version of the Terms will supersede all previous
                versions. Taffinc encourages you to periodically review the
                Terms to stay informed of our updates.
              </p>
            </div>

            <div className="pb-2">
              <h4 className="font-lg font-bold">Contact Us</h4>
              <p className="pb-2">
                Taffinc welcomes your questions or comments regarding the Terms:
              </p>
              <p className="pb-2">
                Techaffinity Consulting, Inc
                <br />
                5331 Primrose Lake Circle
                <br />
                Suite 225
                <br />
                Tampa, Florida 33647
              </p>
              <p className="pb-2">
                Email Address: <br></br>info@taffinc.com
              </p>
              <p className="pb-2">
                Telephone number: <br></br>813-609-2420
              </p>
              <p>Effective as of October 01, 2025</p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 p-6 border-t border-gray-200">
          <button
            type="button"
            onClick={onDecline}
            className="text-primary-dark px-6 py-2 transition-colors font-semibold"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={onAccept}
            className="bg-primary hover:bg-primary-dark text-white px-6 py-2 rounded-md transition-colors font-semibold"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};
